import styled from 'styled-components'
import { TextualFormElement, Container as TextualContainer, ContainerProps } from './TextualFormElement.styles'

interface TextAreaProps {
  resize: 'none' | 'both' | 'horizontal' | 'vertical'
}

export const TextArea = styled(TextualFormElement).attrs({ as: 'textarea' })<TextAreaProps>`
  resize: ${props => props.resize};
  margin: 0;
`

export const Container = styled(TextualContainer)<ContainerProps>`
  height: auto;
`
